import { createUseFetch } from '@ringdna/client/src/react/createUseFetch'

export const useProductPortalToken = createUseFetch<null>({
  key: 'fetch-product-jwt',
  path: '/api/v2/app/productBoard/createToken'
})
